// import Icon from "@mdi/react";
// import MainButton from "../../../components/button/mainButton";
import HeaderBar from "../../../components/header/headerBar";

import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import { Icon } from "@iconify/react";

import { SearchField } from "../../../components/textfield";
import { Children, useEffect, useState } from "react";
import {
  Table,
  Badge,
  Row,
  Col,
  DatePicker,
  Select,
  Input,
  Space,
  Typography,
  Radio,
  Checkbox,
  InputNumber,
  Modal,
  Button,
  Form,
  Spin,
  message,
} from "antd";
import "../../../assets/styles/admin/so.scss";
import { numberWithCommas } from "../../../helpers/functions.js";

import axios from "axios";
import moment from "moment";
interface ParamsType {
  id: string;
}
const BuyCourse = () => {
  const { confirm } = Modal;
  let [formCo_User] = Form.useForm();

  const { Option } = Select;
  const { id } = useParams<ParamsType>();
  const history = useHistory();
  const { Text } = Typography;
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDoc, setIsOpenDoc] = useState(false);
  const [textModal, setTextModal] = useState<any>([]);
  const [couserat1, setCouserat1] = useState<any>([]);
  const [couserat2, setCouserat2] = useState<any>([]);
  const [couserat3, setCouserat3] = useState<any>([]);
  const [couserat4, setCouserat4] = useState<any>([]);
  const [consult, setConSult] = useState<any>([]);
  const [consult2, setConSult2] = useState<any>([]);
  const [updateConsult, setUpdateConsult] = useState<any>([]);
  const [loading, setloading] = useState<any>(false);

  const [doctor, setDocTor] = useState<any>([]);
  const [other, setOther] = useState<string>("");
  const [dataBuySO, setDataBuySO] = useState<any>([]);
  const [purchaseCount, setPurchaseCount] = useState<number>(0);
  const [xcheck, setxcheck] = useState<any>([]);
  const [category, setCategory] = useState<any>([]);
  const [purchaseType, setPurchaseType] = useState<any>([]);
  const [dataHead, setDataHead] = useState<any>([]);
  const [_xid, setxId] = useState<any>("");
  const [optBranch, setOptBranch] = useState<any>([]);
  const [disabledCouser, setdisabledCouser] = useState<any>([]);
  const [checkDoctor, setCheckDoctor] = useState<any>([]);
  const [purchaseSaleType, setPurchaseSaleType] = useState<any>("");
  const [purchaseSaleTypeGift, setPurchaseSaleTypeGift] = useState<any>("");
  const [consults, setConsults] = useState<any>({
    consult1: null,
    consult2: null,
  });
  const [selectedDoctor, setSelectedDoctor] = useState<string>("");
  const [selectedBranch, setSelectedBranch] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<string>("");

  const [isLockByConsult, setIsLockByConsult] = useState<boolean>(true);
  const [isLockByDoctor, setIsLockByDoctor] = useState<boolean>(true);

  const [cashVoucher, setCashVoucher] = useState<any>([]);
  const [isCheckedConsult, setIsCheckConsult] = useState<boolean>(false);
  const [typeSale, setTypeSale] = useState<string>("");

  const dateFormat = "DD-MM-YYYY";

  const columns = [
    {
      title: "รหัส/Code",
      key: "Code",
      align: "center" as "center",
      dataIndex: "code",

      render: (text: any, record: any, index: any) => {
        return (
          <Row justify="start">
            <Space>
              <Icon
                onClick={() => {
                  checkBeforeAddCart(record);
                }}
                icon="akar-icons:circle-plus-fill"
                color="#4d7e7f"
                width="24"
                height="24"
              />

              {text}
            </Space>
          </Row>
        );
      },
    },
    {
      key: "name",
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as "center",
      width: "200px",
    },
    {
      key: "price",
      title: "ราคา/Price",
      dataIndex: "price",
      align: "center" as "center",

      render: (text: any, record: any) => {
        // console.log("record=>", text);

        return numberWithCommas(text, 2);
      },
    },
    {
      key: "quantity",
      title: "จำนวน/Quantity",
      dataIndex: "quantity",
      align: "center" as "center",
      width: "180px",
      render: (text: any, record: any, index: number) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            onClick={() => reduceQuantity(text, index)}
            style={{ cursor: "pointer" }}
          >
            <Icon icon="mdi:menu-left" width="30" height="30" color="#AEAEAE" />
          </div>
          {/* <div>{text}</div> */}
          <InputNumber
            type="number"
            size="middle"
            style={{ width: "20%", justifyContent: "center" }}
            min={1}
            max={10}
            bordered={false}
            value={text}
            controls={false}
          />
          <div
            onClick={() => addQuantity(text, index)}
            style={{ cursor: "pointer" }}
          >
            <Icon
              icon="mdi:menu-right"
              width="30"
              height="30"
              color="#AEAEAE"
            />
          </div>
        </div>
      ),
    },
    {
      key: "number",
      title: "จำนวน/คอร์ส/Number/Course",
      dataIndex: "number",
      align: "center" as "center",
      width: "10px",
      render: (text: any, record: any) => <>{text}</>,
    },
    {
      key: "Commission",
      title: "คอมมิชชั่น/Commission",
      dataIndex: "Commission",
      align: "center" as "center",
      children: [
        {
          title: "พนักงานขาย/Sales",
          dataIndex: "Sales",
          key: "Sales",
          align: "center" as "center",
          width: "10%",
          render: (text: any, record: any, index: number) => {
            return (
              <Space>
                <Form.Item name="checkDoc" className="checkbox-commission">
                  {/* {console.log("Doctor", record?.isCommission)} */}
                  <Checkbox
                    defaultChecked={
                      isLockByConsult ? null : record?.isCommissionSales
                    }
                    disabled={record?.isLockCommissionSales || isLockByConsult}
                    onChange={(e: any) =>
                      // setxcheck({
                      //   ...xcheck,
                      //   comSale: e.target.checked,
                      //   record: record,
                      // })
                      onchangeCommission("comsale", e, index)
                    }
                  ></Checkbox>
                </Form.Item>
                <Text>ได้</Text>
              </Space>
            );
          },
        },
        {
          title: "แพทย์/Doctor",
          dataIndex: "Doctor",
          key: "Doctor",
          align: "center" as "center",

          render: (text: any, record: any, index: number) => {
            return (
              <Space className="checkbox-commission">
                <Checkbox
                  // !record?.isCommissionDoctor
                  disabled={
                    !record?.isDefaultCommissionDoctor || !selectedDoctor
                  }
                  // disabled={!record?.isCommissionDoctor}
                  onChange={(e: any) =>
                    // setxcheck({
                    //   ...xcheck,
                    //   comSale: e.target.checked,
                    //   record: record,
                    // })
                    onchangeCommission("comdoc", e, index, "doctor_commission")
                  }
                  checked={!selectedDoctor ? false : record?.isCommissionDoctor}
                ></Checkbox>
                <Text>ได้</Text>
              </Space>
            );
          },
        },
      ],
      colspan: 2,
    },
    {
      key: "Description",
      title: "คำอธิบาย/Description",
      dataIndex: "detail",
      align: "center" as "center",
    },
  ];

  const columns2 = [
    {
      title: "รหัส/Code",
      align: "center" as "center",
      dataIndex: "code",
      width: "18%",
      render: (text: any, record: any, index: any) => {
        return (
          <Row justify="start">
            <Space>
              <Icon
                onClick={() => {
                  // console.log("text", text);
                  setIsOpen(true);
                  // showDeleteConfirm(record, index);
                  setTextModal(record);
                }}
                icon="akar-icons:circle-plus-fill"
                color="#4d7e7f"
                width="24"
                height="24"
              />
              {`${text}`}
            </Space>
          </Row>
        );
      },
    },
    {
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as "center",
    },
    {
      title: "ราคาโปรโมชั่น/Pro Price",
      dataIndex: "price",
      align: "center" as "center",
      width: "10%",
    },
    {
      title: "วันที่เริ่ม-วันที่หมดอายุ/Start Date Exp Date",
      dataIndex: "startenddate",
      align: "center" as "center",
      width: "13%",
    },
    {
      title: "คอมมิชชั่น/Commission",
      children: [
        {
          title: "พนักงานขาย/Sales",
          align: "center" as "center",
          width: "1%",
          render: (text: any, record: any, index: number) => {
            return (
              <Space className="checkbox-commission">
                {/* {console.log("record", record)} */}
                <Checkbox
                  defaultChecked={
                    isLockByConsult ? null : record?.isCommissionSales
                  }
                  disabled={record?.isLockCommissionSales || isLockByConsult}
                  onChange={(e: any) =>
                    // setxcheck({
                    //   ...xcheck,
                    //   comSale: e.target.checked,
                    //   record: record,
                    // })
                    onchangeCommission("comsale", e, index)
                  }
                ></Checkbox>
                <Text>ได้</Text>
              </Space>
            );
          },
        },
        {
          title: "แพทย์/Doctor",
          align: "center" as "center",
          width: "1%",
          render: (text: any, record: any, index: number) => {
            return (
              <Space className="checkbox-commission">
                <Checkbox
                  // defaultChecked={
                  //   isLockByDoctor ? null : record?.isCommissionDoctor
                  // }
                  disabled={record?.isLockCommissionDoctor || isLockByDoctor}
                  onChange={(e: any) =>
                    // setxcheck({
                    //   ...xcheck,
                    //   comSale: e.target.checked,
                    //   record: record,
                    // })
                    onchangeCommission("comdoc", e, index, "doctor_commission")
                  }
                  checked={!selectedDoctor ? false : record?.isCommissionDoctor}
                ></Checkbox>
                <Text>ได้</Text>
              </Space>
            );
          },
        },
      ],
    },
  ];

  const Onselect = async (record: any, index?: any) => {
    // console.log("record", record);
    // console.log("index", index);

    // console.log("type", purchaseSaleType);
    // console.log("CheckDoctor", checkDoctor);
    // console.log("typeGift", purchaseSaleTypeGift);

    if (purchaseSaleTypeGift !== "Giftvoucher") {
      setloading(true);
    }

    let typeDoc;
    if (selectedDoctor) {
      typeDoc = true;
    } else {
      typeDoc = false;
    }

    let IsDoc;

    if (typeDoc) {
      IsDoc = record?.isCommissionDoctor;
      // console.log("IsDoc if");
    } else {
      IsDoc = false;
      // console.log("IsDoc else");
    }
    // console.log("IsDoc", IsDoc);

    let comsale;
    // console.log("consults", consults);

    if (!consults?.consult1) {
      comsale = false;
    } else {
      comsale = record?.isCommissionSales;
    }

    // console.log("comsale", comsale);

    // console.log("typeDoc", typeDoc);
    // console.log("comdoc", selectedDoctor);
    // console.log("consult", isLockByConsult);
    // let comsale;
    // let comdoc;

    // if (record?.comsale !== undefined) {
    //   comsale = record?.comsale;
    // } else {
    //   comsale = false;
    // }

    // if (record?.comdoc !== undefined) {
    //   comsale = record?.comdoc;
    // } else {
    //   comdoc = typeDoc;
    // }
    let datas = {};

    if (purchaseSaleType === "normal") {
      datas = {
        _id: record?._id,
        quantity: record?.quantity,
        isCommissionSales: comsale,
        isCommissionDoctor: IsDoc,
      };
    } else if (purchaseSaleType === "promotion") {
      datas = {
        _id: record?._id,
        quantity: 1,
        isCommissionSales: comsale,
        isCommissionDoctor: IsDoc,
      };
    } else if (purchaseSaleTypeGift === "Giftvoucher") {
      datas = {
        _id: record?._id,
        quantity: 1,
        isCommissionSales: false,
        isCommissionDoctor: typeDoc,
      };
    }

    console.log("datas", datas);

    // return;
    try {
      const res = await axios.post(`/so/add-item?soId=${_xid}`, datas);
      // console.log("res data =>>>>", res);
      getCountPurchase(res?.data?.productCounts);
      getDatas(other);
    } catch (error: any) {
      console.log("error response =>", error?.response?.data);
      const code = error?.response?.data?.error?.code;
      if (code === "gift-voucher-cart-used") {
        // in cart
        usedVoucher();
      } else if (code === "gift-voucher-used") {
        // in another so list
        usedVoucher();
      }
    }
    if (purchaseSaleType !== "Giftvoucher") {
      setloading(false);
    }
  };

  const onchangeCommission = (
    type: any,
    event: any,
    index: any,
    changeType?: string
  ) => {
    if (type === "comsale") {
      let newBuySo = [...dataBuySO];
      // console.log("newBuySo", newBuySo);
      newBuySo[index].isCommissionSales = event.target.checked;

      setDataBuySO(newBuySo);
    } else if (type === "comdoc") {
      let newBuySo = [...dataBuySO];
      newBuySo[index].isCommissionDoctor = event.target.checked;
      setDataBuySO(newBuySo);
    }

    if (changeType === "doctor_commission") {
      const data = [...dataBuySO];
      if (data && data.length) {
        data[index].isCommissionDoctor = event.target.checked;
        setDataBuySO(data);
      }
    }
  };
  const addQuantity = (values: any, index: any) => {
    let newValue = [...dataBuySO];
    newValue[index].quantity = newValue[index].quantity + 1;
    // newValue[index].total = newValue[index].price * newValue[index].quantity;
    setDataBuySO(newValue);
  };

  const reduceQuantity = (values: any, index: any) => {
    let newValue = [...dataBuySO];
    if (newValue[index].quantity > 1) {
      newValue[index].quantity = newValue[index].quantity - 1;
      // newValue[index].total = newValue[index].price * newValue[index].quantity;
      setDataBuySO(newValue);
    }
  };
  const getBranch = () => {
    axios.get(`/branches?page=1`).then((res) => {
      const xBranch = [];
      for (let i = 0; i < res?.data?.data.length; i++) {
        xBranch.push(
          <Option value={res?.data?.data[i]?._id} key={res?.data?.data[i]?._id}>
            {res?.data?.data[i]?.name}
          </Option>
        );
      }
      setOptBranch(xBranch);
    });
  };
  const getUser = async () => {
    await axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        let datas = res?.data?.data;
        console.log("res", res?.data?.data);

        let x = {
          code: "ไม่ระบุ/Not Specified",
          _id: "",
          name: "ไม่ระบุ/Not Specified",
        };

        datas.push(x);

        const xUser = [];

        for (let i = 0; i < datas?.length; i++) {
          xUser.push(
            <Option value={datas[i]?._id} key={datas[i]?._id}>
              {datas[i]?.name}
            </Option>
          );
        }

        setCouserat1(xUser);
      });
  };

  const getUser2 = async (iduser1?: any) => {
    await axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        //  console.log("data select", data);
        const user1 = formCo_User.getFieldsValue(["Couser1"]);
        // getUser2(data);
        console.log("res user 2", user1.Couser1);
        let datas = res?.data?.data;
        console.log("datas user2 before", datas);

        let x = datas.filter((data: any) => data._id !== user1.Couser1);

        console.log("datas user2", datas);

        let xd = {
          code: "ไม่ระบุ/Not Specified",
          _id: "",
          name: "ไม่ระบุ/Not Specified",
        };

        x.push(xd);
        const xUser = [];

        for (let i = 0; i < x?.length; i++) {
          xUser.push(
            <Option value={x[i]?._id} key={x[i]?._id}>
              {x[i]?.name}
            </Option>
          );
        }
        setCouserat2(xUser);
      });
  };

  const getUser3 = async () => {
    await axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        let datas = res?.data?.data;

        console.log("datas user 3 ", datas);

        const user2 = formCo_User.getFieldsValue(["Couser1", "Couser2"]);

        const x = datas.filter(
          (data: any) =>
            data?._id !== user2?.Couser1 && data?._id !== user2?.Couser2
        );
        console.log("x =>>>", x);
        let xd = {
          code: "ไม่ระบุ/Not Specified",
          _id: "",
          name: "ไม่ระบุ/Not Specified",
        };

        x.push(xd);
        // console.log("res", res?.data?.data);
        const xUser = [];

        for (let i = 0; i < x.length; i++) {
          xUser.push(
            <Option value={x[i]?._id} key={x[i]?._id}>
              {x[i]?.name}
            </Option>
          );
        }

        setCouserat3(xUser);
      });
  };
  const getUser4 = async () => {
    await axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        let datas = res?.data?.data;
        const user3 = formCo_User.getFieldsValue([
          "Couser1",
          "Couser2",
          "Couser3",
        ]);

        const x = datas.filter(
          (data: any) =>
            data?._id !== user3?.Couser1 &&
            data?._id !== user3?.Couser2 &&
            data?._id !== user3?.Couser3
        );
        console.log("x =>>>", x);

        // console.log("res", res?.data?.data);

        let xd = {
          code: "ไม่ระบุ/Not Specified",
          _id: "",
          name: "ไม่ระบุ/Not Specified",
        };

        x.push(xd);
        const xUser = [];

        for (let i = 0; i < x.length; i++) {
          xUser.push(
            <Option value={x[i]?._id} key={x[i]?._id}>
              {x[i]?.name}
            </Option>
          );
        }

        setCouserat4(xUser);
      });
  };

  const getConsult = async () => {
    axios.get(`/users?page=1&branch=all&search=`).then((res) => {
      // console.log("res", res?.data?.data);
      const xConsult = [];
      console.log("ress consult", res?.data?.data);

      const Consult = res?.data?.data.filter(
        (datares: any) => datares?.permission?.name === "Sale"
      );

      let xoptfrees = {
        code: "ไม่ระบุ/Not Specified",
        _id: "",
        displayName: "ไม่ระบุ/Not Specified",
      };
      Consult.push(xoptfrees);

      console.log("consult", Consult);

      for (let i = 0; i < Consult?.length; i++) {
        xConsult.push(
          <Option value={Consult[i]?._id} key={Consult[i]?._id}>
            {Consult[i]?.displayName}
          </Option>
        );
      }
      setConSult(xConsult);
    });
  };

  const onchangeconsult = (value1: any) => {
    console.log("value1", value1);
    setUpdateConsult([]);
    setUpdateConsult([...updateConsult, value1]);
    setConsults({ ...consults, consult1: value1 });
    console.log("purchaseSaleType", purchaseSaleType);

    if (value1) {
      axios
        .patch(`/so/${_xid}`, {
          consults: [value1],
        })
        .then((res) => {
          console.log("res", res?.data);
          getConsult2(value1);
          setIsCheckConsult(true);
          getDatas(purchaseSaleType, "", "", typeSale);
        });
    } else {
      axios
        .patch(`/so/${_xid}`, {
          consults: [],
        })
        .then((res) => {
          console.log("res", res?.data);
          getConsult2(value1);
          setIsCheckConsult(true);
          getDatas(purchaseSaleType, "", "", typeSale);
        });
    }
  };
  const getConsult2 = (value2: any) => {
    // console.log("value consult2", value);

    let xConsultNew = formCo_User.getFieldsValue(["consult1"]);

    console.log("xConsultNew", xConsultNew);

    axios.get(`/users?page=1&branch=all&search=`).then((res) => {
      console.log("res", res?.data?.data);

      const xConsult = [];
      console.log("ress consult2", res?.data?.data);

      const Consult = res?.data?.data.filter(
        (datares: any) =>
          datares?._id !== value2 && datares?.permission?.name === "Sale"
      );

      let xoptfrees = {
        code: "ไม่ระบุ/Not Specified",
        _id: "",
        displayName: "ไม่ระบุ/Not Specified",
      };
      Consult.push(xoptfrees);

      console.log("consult2", Consult);

      for (let i = 0; i < Consult?.length; i++) {
        xConsult.push(
          <Option value={Consult[i]?._id} key={Consult[i]?._id}>
            {Consult[i]?.displayName}
          </Option>
        );
      }
      setConSult2(xConsult);
    });
  };
  const onchangeconsult2 = (value2: any) => {
    // console.log("fom", formCo_User);
    console.log("update consult", updateConsult);

    setConsults({ ...consults, consult2: value2 });

    // if (value2 !== "") {
    //   axios
    //     .patch(`/so/${_xid}`, {
    //       consults: [updateConsult, value2],
    //     })
    //     .then((res) => {
    //       console.log("res", res?.data);
    //       // getConsult2(value1);
    //     });
    // }
  };

  const getDatasHead = async () => {
    await axios.get(`/so/get-new-so?memberId=${id}`).then((res) => {
      let xdata = res.data;

      console.log("consult1 =>>>>>>>>>", xdata?.consults[0]);
      if (xdata?.consults[0] !== undefined) {
        setIsCheckConsult(true);
      }
      console.log("xdata datahead", xdata);

      setTypePrice(xdata);

      console.log("user length", xdata?.coMembers.length);
      // setCheckDoctor({ })
      setSelectedBranch(xdata?.branch ? xdata?.branch : "");
      setSelectedDate(xdata?.date ? xdata?.date : "");
      console.log("date", xdata?.date);

      formCo_User.setFieldsValue({
        branch: xdata?.branch,
        date: xdata?.date !== undefined ? moment(xdata?.date) : "",
        Couser1: xdata?.coMembers[0],
        Couser2: xdata?.coMembers[1],
        Couser3: xdata?.coMembers[2],
        Couser4: xdata?.coMembers[3],
        consult1: xdata?.consults[0],
        consult2: xdata?.consults[1],
        doctor: xdata?.doctor,
        purchaseType: xdata?.purchaseType,
        priceType: xdata?.priceType,
      });

      console.log("check doc", xdata?.doctor);

      getConsultCheck2(xdata?.consults[0], xdata?.consults[1]);

      // set consults
      setConsults({
        ...consults,
        consult1: xdata?.consults[0],
        consult2: xdata?.consults[1],
      });

      // setCheckDoctor({ ...checkDoctor, doctor: xdata?.doctor });

      setSelectedDoctor(xdata?.doctor);

      console.log("check setSelectedDoctor after get api...", xdata?.doctor);

      setOther(xdata?.purchaseType);

      setDataHead({
        ...dataHead,
        customer: xdata?.customer,
        cn: xdata?.customerCode,
        ref: xdata?.code,
      });

      console.log("datahead", dataHead);

      setxId(xdata?._id);
      // console.log("xId So", xdata?._id);

      getCountPurchase(xdata?.productCounts);

      if (xdata?.coMembers.length === 1) {
        setdisabledCouser({
          CoUser2: true,
          CoUser3: true,
          CoUser4: true,
        });
      } else if (xdata?.coMembers.length === 2) {
        setdisabledCouser({
          CoUser2: false,
          CoUser3: true,
          CoUser4: true,
        });
      } else if (xdata?.coMembers.length === 3) {
        setdisabledCouser({
          CoUser2: false,
          CoUser3: false,
          CoUser4: true,
        });
      } else if (xdata?.coMembers.length === 4) {
        setdisabledCouser({
          CoUser2: false,
          CoUser3: false,
          CoUser4: false,
        });
      }
    });
  };

  const onChangeOtherd = (index: string) => {
    console.log("index xxx => ", index);
    console.log("typeSale", purchaseType);

    // getDatas(purchaseType, "", index);
  };
  const getDatas = async (
    typeSale: any,
    catego?: any,
    search?: any,
    typeCode?: string
  ) => {
    console.log("typeSale", typeSale);
    console.log("catego", catego);

    let xcatego = "";
    if (catego !== undefined) {
      xcatego = catego;
    }
    let xSearch = "";

    if (search !== undefined) {
      xSearch = search;
    }

    setDataBuySO([]);
    if (typeSale === "normal") {
      const res = await axios.get(
        `/treatments?page=1&search=${xSearch}&productCategory=${xcatego}`
      );

      const data = res.data.data;

      console.log("data=>>>", data);

      const xdata = [];
      for (let i = 0; i < data.length; i++) {
        xdata.push({
          _id: data[i]?._id,
          code: data[i]?.code,
          name: data[i]?.name,
          detail: data[i]?.detail,
          price:
            typeCode === "Local"
              ? data[i]?.price?.normal?.coursePriceLocal
              : data[i]?.price?.normal?.coursePriceAgency,
          number: data[i]?.number,
          treatmentUnit: data[i]?.treatmentUnit,
          isCommission: data[i]?.isCommission,
          isCommissionDoctor: data[i]?.isCommissionDoctor,
          isCommissionSales: data[i]?.isCommissionSales,
          isDefaultCommissionDoctor: data[i]?.isCommissionDoctor,
          quantity: 1,
          comsale: data[i]?.isCommissionSales,
          comdoc: data[i]?.isCommissionDoctor,
          isLockCommissionSales: !data[i]?.isCommissionSales,
        });
      }

      // console.log("");

      setDataBuySO(xdata);

      console.log("xdata=>>>>>", xdata);

      // // });

      // setCustomer("Ms. A");
      // setChannel("EK-CNF60100015");
      // setDate("2564-12-15");
    } else if (typeSale === "promotion") {
      console.log("isCheckedConsult promo", isCheckedConsult);

      const res = await axios.get(`/promotions?page=&commission=true`);
      const data = res.data.data;

      console.log("data Promotion=>>>", data);
      console.log("substring", data[0]?.startDate.substring(0, 10));
      const xdata = [];

      console.log("check selected doctor v1 =>", selectedDoctor);

      for (let i = 0; i < data.length; i++) {
        xdata.push({
          _id: data[i]?._id,
          code: data[i]?.code,
          name: data[i]?.name,
          price: numberWithCommas(data[i].creditPrice, 2),
          startenddate:
            data[0]?.startDate?.substring(0, 10) +
            "-" +
            data[0]?.endDate?.substring(0, 10),
          number: data[i]?.number,
          treatmentUnit: data[i]?.treatmentUnit,
          promotionType: data[i]?.promotionType,
          isCommissionDoctor: data[i]?.isCommissionDoctor,
          isCommissionSales: data[i]?.isCommissionSales,
          isDefaultCommissionDoctor: data[i]?.isCommissionDoctor,
          isLockCommissionDoctor: data[i]?.isLockCommissionDoctor,
          isLockCommissionSales: data[i]?.isLockCommissionSales,
        });
      }

      const xcheck = xdata.map((x: any) => ({
        ...x,
        comsale: x.promotionType === "normal_limit" ? true : false,
        comdoc: false,
      }));

      setDataBuySO(xcheck);
    }

    setPurchaseSaleType(typeSale);
  };

  const getAPIs = async () => {
    getBranch();
    // getAllDatas();

    getDatasHead();
    getCategory();
    getPurchaseType();
    getConsult();
    getUser();
    getUser2();
    getUser3();
    getUser4();

    getDoctor();
    setxcheck({
      ...xcheck,
      comSale: false,
      comDoc: false,
      record: "",
    });
    setdisabledCouser({
      CoUser2: true,
      CoUser3: true,
      CoUser4: true,
    });
  };
  const getCountPurchase = (values: number) => {
    setPurchaseCount(values);
  };
  useEffect(() => {
    // console.log("xcheck", xcheck);
  }, [xcheck]);

  const OnchangeType = (value: any) => {
    // console.log();
    //// TODO ty
    axios
      .patch(`/so/${_xid}`, {
        purchaseType: value,
      })
      .then((res) => {
        console.log("res typeeee", res?.data);
      });
    console.log("type val ", value);

    setOther(value);
    getDatas(value, "", "", typeSale);
  };
  const getCategory = async () => {
    axios.get(`/product-categories?page=1`).then((res) => {
      const category = res?.data?.data;
      // console.log("category", category);

      const xCate = [];
      for (let i = 0; i < category?.length; i++) {
        xCate.push({
          label: category[i]?.code,
          value: category[i]?._id,
        });
      }
      // console.log("xCate", xCate);

      setCategory(xCate);
    });
  };
  const OnchangeCheckBoxCateType = (e: any) => {
    const xcate = e.join(",");
    // console.log("xcate", xcate);
    getDatas("normal", xcate, "", typeSale);
  };

  // useEffect(() => {
  //   console.log("typeCategory", typeCategory);
  // }, [typeCategory]);

  const getDoctor = async () => {
    const dataDoc = await axios.get(`/users?page=1&branch=all&search=`);
    const xDoctor = [];
    const Doctor = dataDoc?.data?.data.filter(
      (datares: any) => datares?.permission?.name === "CS"
    );

    let xoptfrees = {
      code: "ไม่ระบุ/Not Specified",
      id: "",
      displayName: "ไม่ระบุ/Not Specified",
    };
    Doctor.push(xoptfrees);
    // console.log("Doctor =>>>>", Doctor);

    for (let i = 0; i < Doctor?.length; i++) {
      xDoctor.push(
        <Option value={Doctor[i]?._id} key={Doctor[i]?._id}>
          {Doctor[i]?.displayName}
        </Option>
      );
    }
    setDocTor(xDoctor);
    // const doc = dataDoc.find((x: any) => x.value === subCityId);
  };
  useEffect(() => {
    getAPIs();
    // setOther("Normal");
    console.log("id=>>", id);
    // purchaseChecked();
  }, []);
  useEffect(() => {
    console.log("dataBuySO", dataBuySO);
  }, [dataBuySO]);
  const getPurchaseType = async () => {
    let type = [
      { value: "normal", name: "Normal" },
      { value: "promotion", name: "Promotion" },
    ];

    console.log("type", type);

    const xpurchase = [];
    for (let i = 0; i < type?.length; i++) {
      xpurchase.push(
        <Option value={type[i]?.value} key={type[i]?.value}>
          {type[i]?.name}
        </Option>
      );
    }

    setPurchaseType(xpurchase);
  };

  const onchangeUser1 = (data: any, type: string) => {
    getUser2();
  };
  const onchangeUser2 = (data: any, type: string) => {
    getUser3();
  };
  const onchangeUser3 = (data: any, type: string) => {
    getUser4();
  };
  const onchangeUser4 = (data: any, type: string) => {};

  const onUpdate = (value: any, type: string) => {
    console.log("value", value);

    if (type === "branch") {
      axios
        .patch(`/so/${_xid}`, {
          branch: value,
        })
        .then((res) => {
          console.log("res", res?.data);
        });
      setSelectedBranch(value);
    } else if (type === "date") {
      console.log("data", value);
      if (value !== null) {
        axios
          .patch(`/so/${_xid}`, {
            date: value,
          })
          .then((res) => {
            console.log("res", res?.data);
          });
        setSelectedDate(value);
      }
    }
  };

  const onChangeSelectUser = (values: any) => {
    const a = formCo_User.getFieldsValue([
      "Couser1",
      "Couser2",
      "Couser3",
      "Couser4",
    ]);

    const xuser = Object.values(a).filter((data: any) => data);
    if (xuser[0]) {
      axios
        .patch(`/so/${_xid}`, {
          coMembers: xuser,
        })
        .then((res) => {
          console.log("res updateuser", res?.data);
        });
    } else {
      axios
        .patch(`/so/${_xid}`, {
          coMembers: [],
        })
        .then((res) => {
          console.log("res updateuser", res?.data);
        });
    }
  };
  const OnchangeDoc = (value: any) => {
    console.log("value doctor =>", value);

    setSelectedDoctor(value);

    axios
      .patch(`/so/${_xid}`, {
        doctor: value,
      })
      .then((res) => {
        // console.log("res Doctor=>", res);
        setCheckDoctor({ ...checkDoctor, doctor: value });
      });
  };
  const onKeydownCheck = (eveb: KeyboardEvent) => {
    console.log("e event", eveb.which);
    if (eveb.which !== 8) {
      eveb.preventDefault();
      // message.error("Please Input Max 10 ");
    }
  };

  const useCashVoucher = async (values: any) => {
    const cash = formCo_User.getFieldsValue(["cashVoucherGc"]);
    // console.log("cash", cash);

    if (cash.cashVoucherGc !== undefined && cash.cashVoucherGc !== "") {
      console.log("cashb v1", cash);

      try {
        await axios
          .get(`/gift-vouchers?giftVoucher=gc&code=${cash?.cashVoucherGc}`)
          .then((res: any) => {
            console.log("res", res?.data?.data);
            let voucher = res?.data?.data;
            console.log("voucher", voucher);
            if (voucher.length > 0) {
              setPurchaseSaleTypeGift("Giftvoucher");
              // message.info("มี Giftvoucher");
              console.log("มี Giftvoucher");
              Onselect(voucher[0]);
              // usedVoucher()
            } else {
              validVoucher();
            }

            // Onselect(cash);
          });
      } catch (error: any) {
        console.log("error v1 =>", error);
      }
    }
  };

  const onChangeSelectconsult = (values: any) => {
    const a = formCo_User.getFieldsValue(["consult1", "consult2"]);

    const xuser = Object.values(a).filter((data) => data);
    console.log("xuser", xuser);
    if (xuser) {
      axios
        .patch(`/so/${_xid}`, {
          consults: xuser,
        })
        .then((res) => {
          console.log("res updateuser", res?.data);
        });
    } else {
      axios
        .patch(`/so/${_xid}`, {
          consults: [],
        })
        .then((res) => {
          console.log("res updateuser", res?.data);
        });
    }
  };

  const getConsultCheck2 = (con1: any, con2: any) => {
    axios.get(`/users?page=1&branch=all&search=`).then((res) => {
      console.log("res", res?.data?.data);

      const xConsult = [];
      console.log("ress consult2", res?.data?.data);

      const Consult = res?.data?.data.filter(
        (datares: any) =>
          datares?._id !== con1 && datares?.permission?.name === "Sale"
      );

      let xoptfrees = {
        code: "ไม่ระบุ/Not Specified",
        _id: "",
        displayName: "ไม่ระบุ/Not Specified",
      };
      Consult.push(xoptfrees);

      console.log("consult2", Consult);

      for (let i = 0; i < Consult?.length; i++) {
        xConsult.push(
          <Option value={Consult[i]?._id} key={Consult[i]?._id}>
            {Consult[i]?.displayName}
          </Option>
        );
      }
      setConSult2(xConsult);
    });
  };
  const validVoucher = () => {
    Modal.info({
      className: "button-submit-modal",
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`รหัสบัตรกำนัลเงินสดไม่ถูกต้อง กรุณาลองอีกครั้ง`}</div>
          <div>{`Cash  Voucher Code Is Invalid. Please try again.`}</div>
        </>
      ),
      okText: "ตกลง / Submit",
      width: "fit-content",
    });
  };

  const usedVoucher = () => {
    Modal.info({
      className: "button-submit-modal",
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`รหัสบัตรกำนัลเงินสดนี้ถูกใช้แล้ว`}</div>
          <div>{`This cash voucher code has been used.`}</div>
        </>
      ),
      okText: "ตกลง / Submit",
      width: "fit-content",
    });
  };
  const infoDoctor = (val: any) => {
    Modal.info({
      className: "button-submit-modal",
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="fluent:warning-24-regular"
              color="#86cfc6"
              width="50px"
              height="50px"
              style={{ marginBottom: "25px" }}
            />
          </div>
          <div>{`อย่าลืมเลือกให้ค่าคอมมิชชั่นกับแพทย์ `}</div>
          <div>{`Don't forget choose to give a commission to the doctor.`}</div>
        </>
      ),
      okText: "ตกลง / Submit",
      // okButtonProps: { style: { display: "none" } },
      width: "fit-content",
      onOk() {
        OnchangeDoc(val);
      },
    });
  };

  const onsubmit = (value: any) => {
    if (purchaseCount > 0) {
      history.push(`/opd/so/cart/${id}`);
    } else {
      message.error("เลือกสินค้าในตาราง / Please Select Items !");
    }
  };

  const checkConsultIsLock = () => {
    const { consult1, consult2 } = consults;

    if (consult1 || consult2) {
      setIsLockByConsult(false);
    } else {
      setIsLockByConsult(true);
    }
  };

  const checkDoctorIsLock = (data?: any) => {
    if (!data) {
      data = dataBuySO;
    }

    console.log("checkDoctorIsLock first func......");
    if (selectedDoctor) {
      setIsLockByDoctor(false);
    } else {
      setIsLockByDoctor(true);

      console.log("check doctor lock has false......", data);

      // if (data && data.length) {
      //   console.log("test in if...");

      //   data = data.map((x: any) => ({
      //     ...x,
      //     isCommissionDoctor: false,
      //   }));
      //   setDataBuySO(data);
      // }
    }
  };

  const setCommissionDoctor = () => {
    if (dataBuySO && dataBuySO.length) {
      console.log("test in if...");
      let data = [...dataBuySO];
      data = data.map((x: any) => ({
        ...x,
        isCommissionDoctor: x.isDefaultCommissionDoctor,
      }));
      setDataBuySO(data);
    }
  };

  const uncheckCommissionDoctor = () => {
    console.log("uncheckCommissionDoctor...", dataBuySO);

    if (dataBuySO && dataBuySO.length) {
      console.log("test in if...");
      let data = [...dataBuySO];
      data = data.map((x: any) => ({
        ...x,
        isCommissionDoctor: false,
      }));
      setDataBuySO(data);
    }
  };

  const checkBeforeAddCart = (record: any) => {
    if (selectedBranch && selectedDate) {
      // console.log("text", text);
      setIsOpen(true);
      // showDeleteConfirm(record, index);
      setTextModal(record);
    } else {
      message.error("เลือก สาขา หรือ วันที่ / Please Select Branch and Date");
    }
  };

  const setTypePrice = (xdata: any) => {
    const localPrice = ["CNT", "CNM", "CNS"];
    const agencyPrice = ["CNA", "CNC", "CNE", "CNF"];

    let typecode = "";

    if (localPrice.includes(xdata?.customerTypeCode)) {
      typecode = "Local";
      setTypeSale("Local");
    } else if (agencyPrice.includes(xdata?.customerTypeCode)) {
      typecode = "Agency";
      setTypeSale("Agency");
    }

    getDatas(xdata?.purchaseType, "", "", typecode);
  };

  useEffect(() => {
    console.log("consults has change =>", consults);

    checkConsultIsLock();
  }, [consults]);

  useEffect(() => {
    console.log("selectedDoctor v1 =>", selectedDoctor, dataBuySO);
    checkDoctorIsLock();
  }, [selectedDoctor, dataBuySO]);

  return (
    <div>
      <Form form={formCo_User} onFinish={onsubmit}>
        <HeaderBar title="SO " onClick={() => history.goBack()}>
          <Badge count={purchaseCount}>
            <Button
              style={{
                background: "#4D7E7F",
                color: "white",
                height: "50px",
                borderRadius: "0.25rem",
              }}
              htmlType="submit"
            >
              รายการซื้อ/Purchase Item
            </Button>
          </Badge>
        </HeaderBar>

        <div style={{ margin: "10px 30px" }}>
          <Modal
            visible={isOpen}
            // onClose={onClose}
            footer={false}
            onCancel={() => setIsOpen(false)}
            // style={{ marginLeft: "500px" }}
            // width={"500px"}
            centered
          >
            <>
              {/* {console.log("record", record)} */}
              <Row justify="center">
                <Icon
                  icon="ei:check"
                  color="#5BAEA9"
                  width="20%"
                  height="20%"
                  style={{ marginBottom: "28px" }}
                />
              </Row>
              {/* {console.log("textmodal", textModal)} */}
              <Row justify="center">
                <Col>
                  <h6>
                    ทำการสั่งซื้อ / Make Order
                    {/* {textModal.name}{" "}
                    {textModal?.quantity}{" "}
                    {textModal?.treatmentUnit !== null
                      ? textModal?.treatmentUnit
                      : ""} */}
                  </h6>
                </Col>
              </Row>
              <Row justify="center">
                <Col>
                  <h6>
                    {textModal.name} {textModal?.quantity}
                    {textModal?.treatmentUnit !== null
                      ? textModal?.treatmentUnit
                      : ""}
                  </h6>
                </Col>
              </Row>
              <Row className="Button-Select">
                <Space>
                  <Col className="Select-Button">
                    <Button
                      onClick={() => {
                        setIsOpen(false);
                        Onselect(textModal);
                      }}
                    >
                      เลือกซื้อต่อ/Continue
                    </Button>
                  </Col>
                  <Col className="Continue-Button">
                    <Button
                      onClick={() => {
                        setIsOpen(false);
                        Onselect(textModal);

                        setTimeout(() => {
                          history.push(`/opd/so/cart/${id}`);
                        }, 500);
                      }}
                    >
                      รายการซื้อ/Select Item
                    </Button>
                  </Col>
                  <Col className="Cancle-Button">
                    <Button onClick={() => setIsOpen(false)}>
                      ยกเลิก/Cancel
                    </Button>
                  </Col>
                </Space>
              </Row>
            </>
          </Modal>

          <div className="card-view-custom">
            <Row
              justify="space-around"
              className="custom-card"
              gutter={[16, 16]}
            >
              {/* {console.log("dataHead=>>>>", dataHead)} */}
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ชื่อลูกค้า/Customer Name</p>
                <Input value={dataHead?.customer} disabled></Input>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>รหัสลูกค้า/CN</p>
                <Input value={dataHead?.cn} disabled />
              </Col>
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "4px" }}>
                <p>
                  สาขา/Branch
                  <text style={{ color: "red" }}> *</text>
                </p>
                <Form.Item
                  name="branch"
                  rules={[
                    {
                      required: true,
                      message: "กรุณาเลือกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกสาขา/Branch"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      onUpdate(e, "branch");
                    }}
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {optBranch}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>
                  วันที่/Date
                  <text style={{ color: "red" }}> *</text>
                </p>
                <Form.Item
                  name="date"
                  rules={[
                    {
                      required: true,
                      message: "กรุณาเลือกข้อมูล!",
                    },
                  ]}
                >
                  <DatePicker
                    className="input-dateso"
                    placeholder="Select Date "
                    format={dateFormat}
                    onChange={(e: any) => {
                      onUpdate(e, "date");
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              justify="space-around"
              className="custom-card"
              gutter={[16, 16]}
              style={{ marginTop: "20px" }}
            >
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 1/ Co - User No.1</p>
                <Form.Item
                  name="Couser1"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "กรุณาเลือกข้อมูล!",
                  //   },
                  // ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกผู้ใช้ร่วมที่ 1/Co - User No.1"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      onchangeUser1(e, "couserat1");

                      console.log("e", e);

                      if (e) {
                        setdisabledCouser({
                          CoUser2: false,
                          CoUser3: true,
                          CoUser4: true,
                        });
                      } else {
                        setdisabledCouser({
                          CoUser2: true,
                          CoUser3: true,
                          CoUser4: true,
                        });
                      }
                      formCo_User.setFieldsValue({
                        Couser2: null,
                        Couser3: null,
                        Couser4: null,
                      });
                      onChangeSelectUser(e);
                    }}
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {couserat1}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 2/ Co - User No.2</p>
                <Form.Item name="Couser2">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกผู้ใช้ร่วมที่ 2/Co - User No.2"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      onchangeUser2(e, "couserat2");
                      setdisabledCouser({
                        CoUser3: false,
                        CoUser4: true,
                      });
                      formCo_User.setFieldsValue({
                        Couser3: null,
                        Couser4: null,
                      });
                      onChangeSelectUser(e);
                    }}
                    disabled={disabledCouser.CoUser2}
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {couserat2}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 3/ Co - User No.3</p>
                <Form.Item name="Couser3">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกผู้ใช้ร่วมที่ 3/Co - User No.3"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      onchangeUser3(e, "couserat3");
                      setdisabledCouser({
                        CoUser4: false,
                      });
                      formCo_User.setFieldsValue({
                        Couser4: null,
                      });
                      onChangeSelectUser(e);
                    }}
                    disabled={disabledCouser.CoUser3}
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {couserat3}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 4/ Co - User No.4</p>
                <Form.Item name="Couser4">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกผู้ใช้ร่วมที่ 4/Co - User No.4"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      onchangeUser4(e, "couserat4");
                      onChangeSelectUser(e);
                    }}
                    disabled={disabledCouser.CoUser4}
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {couserat4}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row
              justify="space-around"
              className="custom-card"
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
            >
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "10px" }}>
                <p>ผู้ดูแล 1/Consult 1</p>
                <Form.Item name="consult1">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="ไม่ระบุ/Not Specified"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      formCo_User.setFieldsValue({ consult2: null });
                      onchangeconsult(e);
                      onChangeSelectconsult(e);
                    }}
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {consult}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "10px" }}>
                <p>ผู้ดูแล 2/Consult 2</p>
                <Form.Item name="consult2">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="ไม่ระบุ/Not Specified"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e) => {
                      onchangeconsult2(e);
                      onChangeSelectconsult(e);
                    }}
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {consult2}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "10px" }}>
                <p>แพทย์/Doctor</p>
                <Form.Item name="doctor">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="ไม่ระบุ/Not Specified"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      console.log("e doctor", e);
                      if (e) {
                        console.log("doc change ", checkDoctor);
                        OnchangeDoc(e);
                        setCommissionDoctor();
                      } else {
                        OnchangeDoc(e);
                        // getDatas(other);
                        // setCheckDoctor({ ...checkDoctor, doctor: false });
                        uncheckCommissionDoctor();
                      }
                    }}
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {doctor}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={24}
                sm={4}
                md={6}
                lg={6}
                style={{ marginTop: "40px" }}
              ></Col>
            </Row>
          </div>

          <div className="card-view-custom" style={{ padding: "20px 30px" }}>
            <Row className="custom-card">
              <Col
                xs={24}
                sm={4}
                md={8}
                lg={6}
                // span={6}
              >
                <p>ประเภทการซื้อ/Purchase Type</p>
                <Form.Item name="purchaseType">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกประเภท"
                    // filterOption={(input: any, option: any) =>
                    //   option.children
                    //     .toLowerCase()
                    //     .indexOf(input.toLowerCase()) >= 0
                    // }
                    // showSearch
                    onChange={(value) => {
                      OnchangeType(value);
                    }}
                  >
                    {purchaseType}
                  </Select>
                </Form.Item>
              </Col>
              {/* {console.log("other", other)} */}
              {other === "normal" ? (
                <Col
                  xs={24}
                  sm={24}
                  md={16}
                  lg={16}
                  // span={6}
                >
                  <Checkbox.Group
                    options={category}
                    onChange={OnchangeCheckBoxCateType}
                    style={{ paddingLeft: "40px", marginTop: "35px" }}
                  />
                </Col>
              ) : (
                <>
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    style={{
                      paddingLeft: "10px",
                      marginTop: "-4px",
                    }}
                  >
                    <p>รหัสบัตรกำนัล/Cash Voucher GC</p>
                    <Form.Item name="cashVoucherGc">
                      {/* <Select
                        style={{ width: "100%" }}
                        onSearch={getCashVoucher}
                        mode="tags"
                        showSearch
                        maxTagCount="responsive"
                        onKeyDown={(e: any) => {
                          if (e.target.value.length > 10) {
                            onKeydownCheck(e);
                          }
                        }}
                      >
                        {cashVoucher}
                      </Select> */}
                      <Input
                        placeholder="GC-0000000000"
                        onKeyDown={(e: any) => {
                          if (e.target.value.length >= 11) {
                            onKeydownCheck(e);
                          }
                        }}
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    <Button
                      style={{
                        background: "#4D7E7F",
                        color: "white",
                        height: "50px",
                        borderRadius: "0.25rem",
                        marginTop: "10px",
                        marginLeft: "10px",
                      }}
                      onClick={useCashVoucher}
                    >
                      ใช้ GC/Used GC
                    </Button>
                  </Col>
                </>
              )}
            </Row>
          </div>
          <h4
            className="mt-40"
            style={{
              // textTransform: "uppercase",
              fontSize: "20px",
            }}
          >
            {other === "normal"
              ? "รายการสินค้าและบริการ/Product and Service List"
              : "รายการโปรโมชั่น/Promotional List"}
          </h4>
          {/* <SearchField placeholder="Search   (Name, Code)" color="#fff" /> */}
          {/* <SearchField
            // option={options}
            placeholder="Search  (Name, Code)"
            color="#fff"
            // onChanage={(e: any) => onChangeOtherd(e)}
          /> */}
          {/* <SearchField placeholder="Search   (Name, Code)" color="#fff" /> */}
          <Input.Search
            placeholder="Search for customer (CN, Name, Mobile, ID Card number)"
            onSearch={onChangeOtherd}
            // onChange={(e) => {
            //   setSearch(e.target.value);
            // }}
          />
          <div style={{ marginTop: "20px" }}>
            <div style={{ marginTop: "20px" }} className="table-data">
              <Spin spinning={loading} size="large">
                <Table
                  columns={other === "normal" ? columns : columns2}
                  dataSource={dataBuySO}
                  bordered
                  scroll={{ x: "max-content" }}
                  rowKey="_id"
                />
              </Spin>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};
export default BuyCourse;
